"use client"
import { formatString } from "@/lib/formatString";
import Image from "next/image";
import { useState, useEffect } from "react";

function Toast({ message, isVisible, onClose }) {
    useEffect(() => {
        if (isVisible) {
            const timer = setTimeout(() => {
                onClose();
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [isVisible, onClose]);

    if (!isVisible) return null;

    return (
        <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gray-800 text-white px-6 py-3 rounded-lg shadow-lg z-50 animate-fade-in" style={{ color: 'white' }}>
            {message}
        </div>
    );
}

function formatDateToLong(dateTimeStr) {
    const date = new Date(dateTimeStr.replace(" ", "T")); // Ensure valid ISO format
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
}

export function VNFooter({ blok }) {
    const [toast, setToast] = useState({ message: '', isVisible: false });

    const showToast = (message) => {
        setToast({ message, isVisible: true });
    };

    const hideToast = () => {
        setToast(prev => ({ ...prev, isVisible: false }));
    };

    const handleShare = (platform) => {
        // Get the full URL including protocol and hostname
        const currentUrl = window.location.origin + window.location.pathname;
        const pageTitle = document.title;
        const encodedUrl = encodeURIComponent(currentUrl);
        const encodedTitle = encodeURIComponent(pageTitle);

        switch (platform.toLowerCase()) {
            case 'facebook':
                const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
                window.open(fbUrl, '_blank', 'width=600,height=400');
                break;
            case 'linkedin':
                const liUrl = `https://www.linkedin.com/sharing/share-offsite/?mini=true&url=${encodedUrl}&title=${encodedTitle}&summary=${encodedTitle}&source=${encodedUrl}`;
                window.open(liUrl, '_blank', 'width=600,height=400');
                break;
            case 'instagram':
                navigator.clipboard.writeText(currentUrl)
                    .then(() => showToast('URL copied to clipboard! You can now share it on Instagram.'))
                    .catch(() => showToast('Failed to copy URL. Please try again.'));
                break;
        }
    };

    return (
        <>
            <Toast 
                message={toast.message} 
                isVisible={toast.isVisible} 
                onClose={hideToast} 
            />
            <div style={{
                backgroundSize: "cover", // Ensure the image covers the entire section
                backgroundRepeat: "repeat", // Prevent repeating the background
            }}
                className="max-w-7xl w-full text-center lg:text-left px-4"
            >
                <div className="flex gap-10 lg:gap-28 flex-col xl:flex-row w-full  mb-10" >
                    <div className="flex-2">
                        <div className="flex items-center gap-4 mb-4">
                            <p className="text-center text-[18px] font-normal">{blok.text}</p>
                            <div className="flex justify-center items-center gap-0">
                                {blok.social.map((item, index) => {
                                    return (
                                        <Image 
                                            key={index}
                                            src={item.icon.filename} 
                                            alt={item.icon.alt} 
                                            width={50} 
                                            height={50} 
                                            className="object-contain cursor-pointer hover:opacity-80 transition-opacity" 
                                            onClick={() => handleShare(item.text)}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}